<ng-container>
  <nb-card>
    <nb-card-header>
      <span i18n="@@AdditionalCategoriesHeader">
        Дополнительные категории
      </span>
      <app-choose-catalog-input (removeCatalogEvent)="onRemoveAdditionalCatalogFromModal($event)"
                                (catalogChosenEvent)="onCatalogSelected($event)"
                                [onlyOneSelection]="false"
                                [chooseOnlyLastLevel]="true"
                                *ngIf="canEdit"
                                header=""
                                [chosenCatalogs]="productModel ? productModel.catalogs : []"
                                [excludeCatalogIds]="excludeCatalogIds">

      </app-choose-catalog-input>
    </nb-card-header>
    <nb-card-body style="padding: 4px !important">
      <p *ngIf="!canEdit">Сохраните товар перед редактированием дополнительных категорий</p>
      <ng-container *ngIf="productModel && productModel.catalogs && productModel.catalogs.length">
        <nb-tag-list>
          <nb-tag appearance="outline" status="primary" *ngFor="let catalog of productModel.catalogs" [text]="catalog.header" [removable]="true" (remove)="removeAdditionalCatalog(catalog)"></nb-tag>
        </nb-tag-list>

      </ng-container>
    </nb-card-body>
  </nb-card>
</ng-container>
